/** Status tones shared by StatCard, StatusBadge, Meter and EmptyState. Map to the `status.{tone}.*` semantic tokens. */
export type Tone = "neutral" | "success" | "warning" | "danger" | "info" | "brand";

export interface ToneTokens {
  /** solid fill / icon colour */
  solid: string;
  /** subtle background */
  bg: string;
  /** text on the subtle background (AA+) */
  fg: string;
  /** border on the subtle background */
  border: string;
}

/** Returns the semantic token names for a tone, e.g. toneTokens("danger").solid === "status.danger.solid". */
export const toneTokens = (tone: Tone): ToneTokens => ({
  solid: `status.${tone}.solid`,
  bg: `status.${tone}.bg`,
  fg: `status.${tone}.fg`,
  border: `status.${tone}.border`,
});

/** "r,g,b" of each tone's solid colour, for rgba() pulses/glows in CSS variables. */
export const toneRgb: Record<Tone, string> = {
  success: "82,163,67",
  warning: "245,158,11",
  danger: "220,38,38",
  info: "69,79,168",
  neutral: "140,135,122",
  brand: "107,191,89",
};

/** Green ≤ 80 %, amber ≤ 100 %, red above — the "auto" tone used by consumption meters. */
export const toneForRatio = (ratio: number): Tone => {
  if (!Number.isFinite(ratio) || ratio < 0) return "neutral";
  if (ratio <= 0.8) return "success";
  if (ratio <= 1) return "warning";
  return "danger";
};
